import React from "react";
//#region redux
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { ShareRegisterFooterProps } from "models/propTypes/shareRegisterPropTypes";
import { shareRegisterAccepted, shareRegisterRejected } from "store/actions/shareRegisterActions";
//#endregion
//#region components
import { PageFooter } from "components/common";
import useShareRegisterRejectDialog from "./forms/useShareRegisterRejectDialog";
import { useShareRegisterService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import ShareRegisterToApproveMoreActions from "./moreActions";

const ShareRegisterFooter: React.FC<ShareRegisterFooterProps> = (props) => {
  const shareRegisterService = useShareRegisterService();
  const { markAsDoneHandler, id, disableSuccessMessages } = props;
  const dispatch = useDispatch();

  const onAcceptSuccess = () => {
    markAsDoneHandler && markAsDoneHandler();
    dispatch(shareRegisterAccepted(id));
  };

  const onShareRegisterConfirmationAccept = () => {
    return shareRegisterService.approveShareRegisterConfirmation(id);
  };

  const onRejectSuccess = () => {
    markAsDoneHandler && markAsDoneHandler();
    dispatch(shareRegisterRejected(id));
  };

  const onShareRegisterRejected = async () => {
    dispatch(displayDialog(getRejectDialog(id)));
  };

  const getRejectDialog = useShareRegisterRejectDialog(onRejectSuccess);

  return (
    <PageFooter
      actions={[
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Deny),
          onClick: onShareRegisterRejected,
          type: StyleEnums.DisplayType.Danger,
        },
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Approve),
          onClick: onShareRegisterConfirmationAccept,
          type: StyleEnums.DisplayType.Success,
          successMessage: LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.ShareRegister.ShareRegiterApproveSuccessMessage
          ),
          onActionSuccess: onAcceptSuccess,
        },
      ]}
      moreActions={
        <ShareRegisterToApproveMoreActions
          id={id}
          onActionSuccess={onAcceptSuccess}
          disableSuccessMessages={disableSuccessMessages}
        />
      }
    />
  );
};

export default ShareRegisterFooter;
